import React from 'react';
import { useStyles } from './styles';

export default function Brands() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <img src="/images/stanford-logo.png" alt="Stanford logo" />
      <img src="/images/ucla-logo.png" alt="UCLA logo" />
      <img src="/images/harvard-logo.png" alt="Harvard logo" />
      <img src="/images/pearson-logo.png" alt="Pearson logo" />
      <img src="/images/mcgill-logo.png" alt="Mcgill logo" />
      <img src="/images/servier-logo.png" alt="Servier logo" />
      <img src="/images/gsk-logo.png" alt="Glaxo Smith Kline logo" />
      <img src="/images/ipsen-logo.png" alt="Ipsen logo" />
      <img src="/images/novartis-logo.png" alt="Novartis logo" />
      <img src="/images/novo-nordisk-logo.png" alt="Novo Nordisk logo" />
      <img src="/images/astrazeneca-logo.png" alt="Astrazeneca logo" />
      <img src="/images/pfizer-logo.png" alt="Pfizer logo" />
      <img src="/images/sanofi-logo.png" alt="Sanofi logo" />
      <img src="/images/abbott-logo.png" alt="Abbott logo" />
    </div>
  );
}
